module.exports = __webpack_public_path__ + "img/logos3-01.2708b9d9.png";